import React, { createContext, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { ApiService } from 'modules/ApiService';
import { REPAIR_SERVICE_URL } from 'config';
import { Request } from 'modules/Request';

export const ApiServiceContext = createContext();

export const useRepairServiceApi = () => {
  const { repairServer } = useContext(ApiServiceContext);
  return repairServer;
};

export const ApiProvider = ({ children }) => {
  const history = useHistory();
  const repairServer = new ApiService(REPAIR_SERVICE_URL, Request, history);
  return (
    <ApiServiceContext.Provider value={{ repairServer }}>
      {children}
    </ApiServiceContext.Provider>
  );
};
